import { ApiService } from "../..";

export const deleteSampleGroup = (groupId: string) => {
  return ApiService.baseAction("sample-group/" + groupId, {}, "delete");
};
